export default {"src":"/_next/static/media/vector_2.47b38cc7.svg","height":126,"width":297,"blurWidth":0,"blurHeight":0};